import React, { useState } from 'react';

const ClientLogin = () => {
  const [clientId, setClientId] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    try {
      // For now, redirect to client panel with the provided clientId
      // In a real implementation, you'd validate credentials here
      if (clientId.trim()) {
        window.location.href = `/client/${clientId}`;
      } else {
        setError('Please enter a valid Client ID');
      }
    } catch (err) {
      setError('Login failed. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #3a4f90 0%, #19647e 100%)',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      color: 'white',
      textAlign: 'center',
      padding: '20px'
    }}>
      <div style={{
        maxWidth: '400px',
        background: 'rgba(255, 255, 255, 0.1)',
        borderRadius: '20px',
        padding: '40px',
        backdropFilter: 'blur(10px)',
        border: '1px solid rgba(255, 255, 255, 0.2)'
      }}>
        {/* Sellflows Logo */}
        <div style={{
          marginBottom: '30px',
          display: 'flex',
          justifyContent: 'center'
        }}>
                     <img 
             src="/sellflows-logo-white.png"
             alt="Sellflows"
             style={{
               width: '200px',
               height: '60px',
               objectFit: 'contain',
               borderRadius: '10px',
               border: '1px solid rgba(255, 255, 255, 0.3)',
               background: 'rgba(255, 255, 255, 0.1)'
             }}
           />
        </div>
        
        <h1 style={{
          fontSize: '2rem',
          marginBottom: '20px',
          fontWeight: 'bold'
        }}>
          Client Login
        </h1>
        
        <p style={{
          fontSize: '1rem',
          marginBottom: '30px',
          opacity: '0.9'
        }}>
          Access your widget configuration
        </p>
        
        <form onSubmit={handleSubmit} style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '20px'
        }}>
          <div>
            <label style={{
              display: 'block',
              marginBottom: '8px',
              textAlign: 'left',
              fontSize: '0.9rem'
            }}>
              Client ID:
            </label>
                         <input
               type="text"
               value={clientId}
               onChange={(e) => setClientId(e.target.value)}
               placeholder="Enter your Client ID"
               style={{
                 width: '100%',
                 padding: '12px',
                 borderRadius: '8px',
                 border: '1px solid rgba(255, 255, 255, 0.3)',
                 background: 'rgba(255, 255, 255, 0.1)',
                 color: 'white',
                 fontSize: '1rem'
               }}
               required
             />
             <style>
               {`
                 input::placeholder {
                   color: rgba(255, 255, 255, 0.7) !important;
                 }
               `}
             </style>
          </div>
          
          <div>
            <label style={{
              display: 'block',
              marginBottom: '8px',
              textAlign: 'left',
              fontSize: '0.9rem'
            }}>
              Password:
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your password"
              style={{
                width: '100%',
                padding: '12px',
                borderRadius: '8px',
                border: '1px solid rgba(255, 255, 255, 0.3)',
                background: 'rgba(255, 255, 255, 0.1)',
                color: 'white',
                fontSize: '1rem'
              }}
              required
            />
          </div>
          
          {error && (
            <div style={{
              color: '#ff6b6b',
              fontSize: '0.9rem',
              padding: '10px',
              background: 'rgba(255, 107, 107, 0.1)',
              borderRadius: '8px',
              border: '1px solid rgba(255, 107, 107, 0.3)'
            }}>
              {error}
            </div>
          )}
          
          <button
            type="submit"
            disabled={isLoading}
            style={{
              padding: '12px 24px',
              borderRadius: '8px',
              border: '1px solid rgba(255, 255, 255, 0.3)',
              background: isLoading ? 'rgba(255, 255, 255, 0.1)' : 'rgba(255, 255, 255, 0.2)',
              color: 'white',
              fontSize: '1rem',
              cursor: isLoading ? 'not-allowed' : 'pointer',
              transition: 'all 0.3s ease'
            }}
            onMouseEnter={(e) => {
              if (!isLoading) {
                e.target.style.background = 'rgba(255, 255, 255, 0.3)';
              }
            }}
            onMouseLeave={(e) => {
              if (!isLoading) {
                e.target.style.background = 'rgba(255, 255, 255, 0.2)';
              }
            }}
          >
            {isLoading ? 'Logging in...' : 'Login'}
          </button>
        </form>
        
        <div style={{
          marginTop: '30px',
          fontSize: '0.9rem',
          opacity: '0.7'
        }}>
          <a 
            href="/"
            style={{
              color: 'white',
              textDecoration: 'none',
              borderBottom: '1px solid rgba(255, 255, 255, 0.3)'
            }}
          >
            ← Back to Home
          </a>
        </div>
      </div>
    </div>
  );
};

export default ClientLogin; 
